import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  topValue?: string;
  requestedAccess?: boolean;
};

interface IBarContainerProps {
  height?: number;
};

export const Root = styled.div`
  max-height: 646px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ScrollContainer = styled.div`
  width: 562px;
  padding: 25px 0px;
`;

export const Row = styled.div`
  display: flex;
  padding: 0px 39px;
`;

export const TextArea = styled.textarea`
  margin-top: 12px;
  width: 100%;
  padding: 13px 14.1px;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: var(--white);
  font-family: Roboto;
  font-size: 12px;
  color: #202020;
  resize: none;
  overflow: hidden;
  outline: none;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${C.GRAY};
`

export const EditPermissionsContainer = styled.div`
  padding: 20px 0px;
`

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 0px;
  position: relative;
`

export const Owner = styled.div`
  width: 130px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8d8d8d;
`

export const UserName = styled.div`
  padding-left: 13px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props: IProps) => props.requestedAccess ? C.ORANGE : C.DARK_GRAY};
`

export const RequestedAccessLabel = styled.span`
  position: absolute;
  bottom: 2px;
  left: 52px;
  width: 180px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.VARIANT_GRAY};
`;

export const UsersPermissionContainer = styled.div`
`

export const UserPermissionRow = styled.div`
  padding: 0px 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`

export const TopCopyLinkMessage = styled.div`
  padding: 29px 0px 0px 39px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(112, 112, 112, 0.5);
`

export const CopyLinkContainer = styled.div`
  position: relative;
  display: flex;
`

export const CopyMessageContainer = styled.div`
  position: absolute;
  left: 195px;
  top: ${(props: IProps) => (props.topValue ?? `0px`)};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 5px 12px;
  min-width: 130px;
  max-width: 356px;
  background-color: ${C.DARKEST_GRAY};
  box-sizing: border-box;
`

export const CheckIconContainer = styled.div`
  height: 23px;
  padding-right: 6px;
`

export const CopyMessage = styled.div`
  padding: 5px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
`
